import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-adddocumentdetails',
  templateUrl: './adddocumentdetails.component.html',
  styleUrls: ['./adddocumentdetails.component.css']
})
export class AdddocumentdetailsComponent implements OnInit {


  constructor(private toastr: ToastrService, private appService: AppdataService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) { }

  //Save Validation
  submitted: boolean;
  successfully: boolean;

  iserrorfilesize:boolean=false

  @Input() documentid: any = 0;
  

  @Output() emitData = new EventEmitter();


  //set image
  image;
  strImage: any;
  picurl: string = "";
  picname: string = "";
  doctype: string = "";
  filename: string = "";
  filesize: string = "";

  settingsColl: any = [];

  imagerestrictsize: number = 70;
  documentrestrictsize: number = 70;

  ngOnInit() {
    this.fngetSettings();
  }



  //Image Import
  changeListener($event): void {
    try {
      this.readThis($event.target);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  readThis(inputValue: any): void {

    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();
    
    var filetype = inputValue.files[0].name.split(".").pop();
    var filename = inputValue.files[0].name;
    var filesize = inputValue.files[0].size;
   


    myReader.onloadend = (e) => {
      this.image = myReader.result;
      this.strImage = this.image.split(',')[1];
      this.doctype = filetype;
      this.filename = filename;
      this.filesize = filesize;

     
      this.iserrorfilesize = false;
      if (filesize / 1000 > this.imagerestrictsize) { 
        this.image = null;
        this.strImage = null;
        this.picurl = "";
        this.iserrorfilesize = true;
        return;
      }
  

    }
    myReader.readAsDataURL(file);
  }

  removeimage() {
    this.image = null;
    this.strImage = null;
    this.picurl = "";
    this.iserrorfilesize = false;
  }

  fnOpenFileBrowser(event: any) {

    event.preventDefault();

    let element: HTMLElement = document.getElementById('image') as HTMLElement;
    element.click();

  }



  fnSaveBtnClick() {
    try {

      if (this.strImage != null) {
        var data = {
          documentid: this.documentid,               
          doctype: this.doctype,
          docstrimage: this.strImage,         
        }
        this.emitData.emit(data);
        this.activeModal.close(true);

        
      }
           


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  
  //Get
  fngetSettings() {   
    var data = {
        'settingsid':0,
        'companyid': this.loginService.fnGetCompanyId(),                                                                       
    }
    this.appService.getSettings(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
           //   this.settingsgroupColl=res.json().result[0]; 
            this.settingsColl = res.json().result[1]; 
           
            this.fnCheckCompany();
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
}

  
  fnCheckCompany() {
    
    for (let abo of this.settingsColl) {
      if (abo.settingsname === 'IMAGEUPLOADSIZE') {
        if(Number(abo.settingsvalue)>0){
          this.imagerestrictsize=Number(abo.settingsvalue);
        }       
      }

      if (abo.settingsname === 'DOCUMENTUPLOADSIZE') {
        if(Number(abo.settingsvalue)>0){
          this.documentrestrictsize=Number(abo.settingsvalue);
        }      
      }
    }

  }
  

  public decline() {
    this.activeModal.close(false);
  }


  
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
